import { render, staticRenderFns } from "./feature-list.vue?vue&type=template&id=096013ce&scoped=true"
import script from "./feature-list.vue?vue&type=script&lang=js"
export * from "./feature-list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "096013ce",
  null
  
)

export default component.exports